export enum RouterPath {
  Root = '/',
  Hub = 'hub',
  Home = 'home',
  Login = 'login',
  Membership = 'membership',
  MyBookings = 'my-bookings',
  MakeAppointment = 'make-appointment',
  HealthDeclaration = 'health-declaration',
  PartialPayment = 'partial-payment',
  Journal = 'journal',
  MyProfile = 'my-profile',
  Help = 'help',
}
